import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoaderHandlerService } from '../../services/loader-handler.service';

@Component({
    selector: 'app-overlay-loader',
    templateUrl: './overlay-loader.component.html',
    styleUrls: ['./overlay-loader.component.scss'],
    standalone: false
})
export class OverlayLoaderComponent {
  public showLoader: any = false;
  subscription: any;

  constructor(private loaderHandler: LoaderHandlerService) {
    this.subscription = this.loaderHandler.handler$.subscribe((value) => {
      this.showLoader = value;
    });
  }

}
